"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsTableComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_1 = require("react");
var doshx_controls_web_1 = require("doshx_controls_web");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var pages_1 = require("../../../../../../constants/pages");
var constants_1 = require("../constants");
var get_all_scan_scripts_thunk_1 = require("../../../../../../reducers/slices/scanScript/thunks/get_all_scan_scripts_thunk");
var scanScript_1 = require("../../../../../../reducers/slices/scanScript/scanScript");
var branch_list_thunk_1 = require("../../../../../../reducers/slices/branch/thunks/get/branch_list_thunk");
var table_filters_1 = __importDefault(require("./table_filters"));
var update_scan_script_status_thunk_1 = require("../../../../../../reducers/slices/scanScript/thunks/update_scan_script_status_thunk");
var main_1 = require("../../../../../../reducers/slices/main");
var routes_1 = require("../../../../../../constants/routes");
var useSearchDebounce_1 = require("../../../../../../hooks/useSearchDebounce");
var DocumentsTableComponent = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, useSearchDebounce_1.useSearchDebounce)(), search = _a[0], setSearch = _a[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.scanScriptState; }), scanScripts = _b.scanScripts, pagination = _b.pagination, loading = _b.loading;
    var _c = (0, react_redux_1.useSelector)(function (state) { return state.branchState; }), branches = _c.branches, branchPagination = _c.pagination;
    var _d = (0, react_1.useState)({
        client_id: user.client_id,
        status: "",
        branch_id: null,
        branch_id_list: user.role === "ADMIN" ? null : user.manager_of,
        from_date: "",
        to_date: "",
        page: pagination.page,
        size: pagination.size,
    }), filters = _d[0], setFilters = _d[1];
    var _e = (0, react_1.useState)(false), showFilters = _e[0], setShowFilters = _e[1];
    (0, react_1.useEffect)(function () {
        if ((branches === null || branches === void 0 ? void 0 : branches.length) === 0) {
            dispatch((0, branch_list_thunk_1.branch_list_thunk)(branchPagination));
        }
    }, []);
    (0, react_1.useEffect)(function () {
        getDocuments({ search_string: search ? search : null });
    }, [search]);
    var getDocuments = function (filter) {
        var fl = __assign(__assign({}, filters), filter);
        if (!fl.search_string)
            delete fl.search_string;
        dispatch((0, get_all_scan_scripts_thunk_1.get_all_scan_scripts_thunk)(fl));
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "w-full flex flex-col gap-4" }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-between" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faSlidersSimple, size: "small", backgroundColor: "bg-primary", iconColor: "text-white", onClick: function () { return setShowFilters(!showFilters); } }), showFilters && (0, jsx_runtime_1.jsx)(table_filters_1.default, { filters: filters, setFilters: setFilters })] })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.TextInputControl, { borderColor: "border-borders", backgroundColor: "bg-white", label: "Search", endIcon: pro_light_svg_icons_1.faSearch, 
                                // value={search}
                                size: "small", onChange: function (v) {
                                    setSearch(v);
                                } })] })), loading ? ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.CircularLoaderControl, { size: "xlarge" })) : ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.TableControl, { columns: constants_1.DOCUMENT_TABLE_COLUMNS, 
                        // rowActions={}
                        data: scanScripts, hasShadow: true, pagination: {
                            currentPage: pagination.page,
                            rowsPerPage: pagination.size,
                            totalRecords: pagination.countTotal,
                            onPageChange: function (page) {
                                getDocuments({ page: page });
                            },
                            onRowsPerPageChange: function (size) {
                                getDocuments({ size: size });
                            },
                        }, colors: pages_1.tableColorConfig, rowActions: [
                            {
                                label: "Details",
                                onClick: function (data) {
                                    dispatch((0, scanScript_1.setSelectedScanScriptID)(data._id));
                                    navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.DOCUMENT_DETAILS_ROUTE));
                                },
                            },
                            {
                                label: "Process",
                                onClick: function (data) {
                                    if (data.status !== constants_1.DOCUMENTS_STATUSES.processed) {
                                        dispatch((0, update_scan_script_status_thunk_1.update_scan_script_status_thunk)({
                                            _id: data._id,
                                            status: constants_1.DOCUMENTS_STATUSES.processed,
                                            user: {
                                                _id: user._id,
                                                display_name: "".concat(user.name, " ").concat(user.surname),
                                            },
                                        }));
                                    }
                                    else {
                                        dispatch((0, main_1.setMessageModal)({ title: "Info!", messages: ["Document already ".concat(constants_1.DOCUMENTS_STATUSES.processed.toLocaleLowerCase())] }));
                                    }
                                },
                            },
                        ] }))] })) }) })));
};
exports.DocumentsTableComponent = DocumentsTableComponent;
